import { c as _c } from "react/compiler-runtime";
import { FieldLabel, FormInputNumber } from '@systemeio/ui';
import { TagInterface } from 'modules/newsletters/single/types/newsletter-interface';
import { useTagsAll } from 'modules/tags/hooks/use-tags-all';
import React, { useMemo } from 'react';
import { DisclosureBox } from 'shared/components/disclosure-box';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twJoin } from 'tailwind-merge';
import { DashboardMailEditorCommonProps } from '../../types/common';
import TagsBlock from './tags-block';
export interface Tags {
  included: TagInterface['id'][];
  excluded: TagInterface['id'][];
}
export interface ContactsSettings {
  tags: Tags;
  daysExists: number;
}
export interface ContactsSettingsBlockProps extends Pick<DashboardMailEditorCommonProps, 'isPreFetching' | 'inModal' | 'disabled'> {
  contactsSettings: ContactsSettings;
  onChangeContactsSettings: (value: ContactsSettings) => void;
}
const ContactsSettingsBlock = t0 => {
  const $ = _c(109);
  const {
    disabled,
    isPreFetching,
    contactsSettings: t1,
    onChangeContactsSettings,
    inModal
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {
      daysExists: 0,
      tags: {
        included: [],
        excluded: []
      }
    } : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const contactsSettings = t2;
  const {
    t
  } = useLocoTranslation();
  const {
    tags: listOfTags
  } = useTagsAll();
  let t3;
  if ($[2] !== listOfTags?.items) {
    t3 = listOfTags?.items.map(_temp);
    $[2] = listOfTags?.items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const listOfTagsOptions = t3;
  const isLoading = !listOfTags || isPreFetching;
  const t4 = inModal && "border border-text-secondary/30 rounded-lg";
  let t5;
  if ($[4] !== t4) {
    t5 = twJoin(t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t) {
    t6 = t("dashboard.contact_email_settings.block_title");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <b className="text-text-primary text-start text-[17px]">{t6}</b>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t) {
    t8 = t("dashboard.contact_email_settings.registered_over_input.label");
    $[10] = t;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <FieldLabel label={t8} />;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t) {
    t10 = t("dashboard.contact_email_settings.registered_over_input.registered_over");
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <span>{t10}</span>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== contactsSettings || $[19] !== onChangeContactsSettings) {
    t12 = value => onChangeContactsSettings({
      ...contactsSettings,
      daysExists: value
    });
    $[18] = contactsSettings;
    $[19] = onChangeContactsSettings;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== contactsSettings.daysExists || $[22] !== disabled || $[23] !== isLoading || $[24] !== t12) {
    t13 = <FormInputNumber disabled={disabled} isPreFetching={isLoading} value={contactsSettings.daysExists} onChange={t12} type="integer" className="ml-2 mr-2" inputClassName="field-sizing-content" />;
    $[21] = contactsSettings.daysExists;
    $[22] = disabled;
    $[23] = isLoading;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t) {
    t14 = t("dashboard.contact_email_settings.registered_over_input.days_ago");
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14) {
    t15 = <span>{t14}</span>;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t11 || $[31] !== t13 || $[32] !== t15) {
    t16 = <div className="flex-start mt-1 flex w-full items-center">{t11}{t13}{t15}</div>;
    $[30] = t11;
    $[31] = t13;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16 || $[35] !== t9) {
    t17 = <div>{t9}{t16}</div>;
    $[34] = t16;
    $[35] = t9;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("dashboard.contact_email_settings.tags_selector.include_title");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== contactsSettings || $[40] !== listOfTagsOptions || $[41] !== onChangeContactsSettings) {
    t19 = data => {
      onChangeContactsSettings({
        ...contactsSettings,
        tags: {
          ...contactsSettings.tags,
          included: listOfTagsOptions?.filter(t20 => {
            const {
              id: id_0
            } = t20;
            return (data || []).includes(id_0);
          }).map(_temp2) || []
        }
      });
    };
    $[39] = contactsSettings;
    $[40] = listOfTagsOptions;
    $[41] = onChangeContactsSettings;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== contactsSettings || $[44] !== onChangeContactsSettings) {
    t20 = currentId => onChangeContactsSettings({
      ...contactsSettings,
      tags: {
        ...contactsSettings.tags,
        included: contactsSettings.tags.included.filter(id_2 => id_2 !== currentId)
      }
    });
    $[43] = contactsSettings;
    $[44] = onChangeContactsSettings;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== contactsSettings || $[47] !== listOfTagsOptions || $[48] !== onChangeContactsSettings) {
    t21 = () => onChangeContactsSettings({
      ...contactsSettings,
      tags: {
        ...contactsSettings.tags,
        included: listOfTagsOptions?.map(_temp3) || []
      }
    });
    $[46] = contactsSettings;
    $[47] = listOfTagsOptions;
    $[48] = onChangeContactsSettings;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== contactsSettings || $[51] !== onChangeContactsSettings) {
    t22 = () => onChangeContactsSettings({
      ...contactsSettings,
      tags: {
        ...contactsSettings.tags,
        included: []
      }
    });
    $[50] = contactsSettings;
    $[51] = onChangeContactsSettings;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== contactsSettings.tags.included || $[54] !== disabled || $[55] !== isLoading || $[56] !== listOfTagsOptions || $[57] !== t18 || $[58] !== t19 || $[59] !== t20 || $[60] !== t21 || $[61] !== t22) {
    t23 = <TagsBlock type="included" title={t18} disabled={disabled} required={true} listOfTagsOptions={listOfTagsOptions} tagsList={contactsSettings.tags.included} isPreFetching={isLoading} onChangeMultiselect={t19} onClickTagLabel={t20} onSelectAll={t21} onUnselectAll={t22} />;
    $[53] = contactsSettings.tags.included;
    $[54] = disabled;
    $[55] = isLoading;
    $[56] = listOfTagsOptions;
    $[57] = t18;
    $[58] = t19;
    $[59] = t20;
    $[60] = t21;
    $[61] = t22;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== t) {
    t24 = t("dashboard.contact_email_settings.tags_selector.exclude_title");
    $[63] = t;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  let t25;
  if ($[65] !== contactsSettings || $[66] !== listOfTagsOptions || $[67] !== onChangeContactsSettings) {
    t25 = data_0 => {
      onChangeContactsSettings({
        ...contactsSettings,
        tags: {
          ...contactsSettings.tags,
          excluded: listOfTagsOptions?.filter(t26 => {
            const {
              id: id_4
            } = t26;
            return (data_0 || []).includes(id_4);
          }).map(_temp4) || []
        }
      });
    };
    $[65] = contactsSettings;
    $[66] = listOfTagsOptions;
    $[67] = onChangeContactsSettings;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  let t26;
  if ($[69] !== contactsSettings || $[70] !== onChangeContactsSettings) {
    t26 = currentId_0 => onChangeContactsSettings({
      ...contactsSettings,
      tags: {
        ...contactsSettings.tags,
        excluded: contactsSettings.tags.excluded.filter(id_6 => id_6 !== currentId_0)
      }
    });
    $[69] = contactsSettings;
    $[70] = onChangeContactsSettings;
    $[71] = t26;
  } else {
    t26 = $[71];
  }
  let t27;
  if ($[72] !== contactsSettings || $[73] !== listOfTagsOptions || $[74] !== onChangeContactsSettings) {
    t27 = () => onChangeContactsSettings({
      ...contactsSettings,
      tags: {
        ...contactsSettings.tags,
        excluded: listOfTagsOptions?.map(_temp5) || []
      }
    });
    $[72] = contactsSettings;
    $[73] = listOfTagsOptions;
    $[74] = onChangeContactsSettings;
    $[75] = t27;
  } else {
    t27 = $[75];
  }
  let t28;
  if ($[76] !== contactsSettings || $[77] !== onChangeContactsSettings) {
    t28 = () => onChangeContactsSettings({
      ...contactsSettings,
      tags: {
        ...contactsSettings.tags,
        excluded: []
      }
    });
    $[76] = contactsSettings;
    $[77] = onChangeContactsSettings;
    $[78] = t28;
  } else {
    t28 = $[78];
  }
  let t29;
  if ($[79] !== contactsSettings.tags.excluded || $[80] !== disabled || $[81] !== isLoading || $[82] !== listOfTagsOptions || $[83] !== t24 || $[84] !== t25 || $[85] !== t26 || $[86] !== t27 || $[87] !== t28) {
    t29 = <TagsBlock type="excluded" title={t24} disabled={disabled} listOfTagsOptions={listOfTagsOptions} tagsList={contactsSettings.tags.excluded} isPreFetching={isLoading} onChangeMultiselect={t25} onClickTagLabel={t26} onSelectAll={t27} onUnselectAll={t28} />;
    $[79] = contactsSettings.tags.excluded;
    $[80] = disabled;
    $[81] = isLoading;
    $[82] = listOfTagsOptions;
    $[83] = t24;
    $[84] = t25;
    $[85] = t26;
    $[86] = t27;
    $[87] = t28;
    $[88] = t29;
  } else {
    t29 = $[88];
  }
  let t30;
  if ($[89] !== t) {
    t30 = t("dashboard.contact_email_settings.tags_selector.note_1");
    $[89] = t;
    $[90] = t30;
  } else {
    t30 = $[90];
  }
  let t31;
  if ($[91] !== t30) {
    t31 = <span>{t30}</span>;
    $[91] = t30;
    $[92] = t31;
  } else {
    t31 = $[92];
  }
  let t32;
  if ($[93] !== t) {
    t32 = t("dashboard.contact_email_settings.tags_selector.note_2");
    $[93] = t;
    $[94] = t32;
  } else {
    t32 = $[94];
  }
  let t33;
  if ($[95] !== t32) {
    t33 = <span>{t32}</span>;
    $[95] = t32;
    $[96] = t33;
  } else {
    t33 = $[96];
  }
  let t34;
  if ($[97] !== t31 || $[98] !== t33) {
    t34 = <div className="flex flex-col gap-2">{t31}{t33}</div>;
    $[97] = t31;
    $[98] = t33;
    $[99] = t34;
  } else {
    t34 = $[99];
  }
  let t35;
  if ($[100] !== t17 || $[101] !== t23 || $[102] !== t29 || $[103] !== t34) {
    t35 = <>{t17}{t23}{t29}{t34}</>;
    $[100] = t17;
    $[101] = t23;
    $[102] = t29;
    $[103] = t34;
    $[104] = t35;
  } else {
    t35 = $[104];
  }
  let t36;
  if ($[105] !== t35 || $[106] !== t5 || $[107] !== t7) {
    t36 = <DisclosureBox defaultOpen={true} wrapperClassName={t5} title={t7}>{t35}</DisclosureBox>;
    $[105] = t35;
    $[106] = t5;
    $[107] = t7;
    $[108] = t36;
  } else {
    t36 = $[108];
  }
  return t36;
};
export default ContactsSettingsBlock;
function _temp(t0) {
  const {
    id,
    name
  } = t0;
  return {
    id,
    caption: name
  };
}
function _temp2(t0) {
  const {
    id: id_1
  } = t0;
  return id_1;
}
function _temp3(t0) {
  const {
    id: id_3
  } = t0;
  return id_3;
}
function _temp4(t0) {
  const {
    id: id_5
  } = t0;
  return id_5;
}
function _temp5(t0) {
  const {
    id: id_7
  } = t0;
  return id_7;
}